export default "__VITE_ASSET__BOHByRl8__"